<ul class="layout-menu">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <li *ngIf="menuErrorMessage" class="p-2 text-sm text-500" style="white-space: normal;">
        <i class="pi pi-exclamation-triangle mr-2"></i>{{ menuErrorMessage }}
    </li>
</ul>